// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOrderMobile_container__PaNa7"};